<script>
import Layout from '../../../layouts/auth'
import appConfig from '@/app.config'
import { email, required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import * as verificationApi from '@/services/rest-api-identity/lib/verification/verification'
import { patchProfile } from '@/services/rest-api-vsms/lib/profile/profile'

export default {
  page: {
    title: 'Tambah Email',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  mixins: [Helper],
  data() {
    return {
      email: null,
      invalidEmail: false,
    }
  },
  validations: {
    email: {
      required,
      email,
      invalidEmail: true,
    },
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    profile() {
      return this.$store.state.access.profile
    },
  },
  mounted() {
    this.adjustImageSize()
    this.$v.$touch()
  },
  methods: {
    async handleSubmit() {
      this.$v.$touch()

      const INTERNAL_USER_API =
        process.env.VUE_APP_ENV === 'production'
          ? process.env.VUE_APP_INTERNAL_USER_PROD_API
          : process.env.VUE_APP_INTERNAL_USER_API

      try {
        const patchUserResponse = await patchProfile({
          email: this.email,
        })

        if (!patchUserResponse?.status) {
          this.$mcToast.error(this.$t('profile.update.emailExist'))
          return
        }

        const verifResponse = await verificationApi.sendEmailVerification({
          resource_url: `${INTERNAL_USER_API}${this.profile.userId}`,
          verification_type: 'email',
          email: this.email,
        })

        if (!verifResponse.status) {
          this.$mcToast.error(this.$t('profile.update.failedSend'))
        }

        this.$mcToast.success(this.$t('profile.update.dataSaved'))
        setTimeout(() => {
          window.location.href = '/profile'
        }, 1000)
      } catch (error) {
        this.$mcToast.error(this.$t('profile.update.failed'))
        this.isSubmit = false
      }
    },
    adjustImageSize() {
      this.resizeImage(this.$refs.imgPrimaryLogo, 45, 150)
      this.resizeImage(this.$refs.imgCopyrightLogo, 15, 50)
    },
  },
}
</script>
<style scoped lang="scss">
@mixin custom-tooltip-styles {
  position: absolute;
  padding: 10px;
  background: $white;
  z-index: 1;
  border: 1px solid $teal-200;
  border-radius: 4px;
  &:before {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 5px 5px;
    border-color: $teal-200 transparent;
    left: 50%;
    top: -2px;
    transform: translate(-50%, -50%);
  }
  &:after {
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 4px 4px;
    border-color: $white transparent;
    left: 50%;
    top: -1px;
    transform: translate(-50%, -50%);
  }
}

.custom-tooltip {
  @include custom-tooltip-styles;
  transform: translate(19%, -1%);
  ul li label {
    max-width: 233px;
  }
}

.custom-tooltip-repassword {
  @include custom-tooltip-styles;
  transform: translate(50%, -1%);
}

.icon-success:before {
  color: $success;
  font-size: 14px;
}
.icon-danger:before {
  color: $danger;
  font-size: 14px;
}
</style>
<template>
  <Layout>
    <div class="mc-auth__form">
      <h1 class="mc-auth__logo pt-5">
        <router-link to="/">
          <img :src="getAsset('primaryLogo', 'login')" alt ref="imgPrimaryLogo" />
        </router-link>
      </h1>
      <div class="mc-auth__form-wrapper mc-auth__form-wrapper--forgot">
        <h4 class="mc-auth__label">{{ $t('profile.add.email.title') }}</h4>
        <p>{{ $t('profile.add.email.description') }}</p>
        <b-form @submit.prevent="handleSubmit">
          <b-form-group class="mb-2 form-password text-start" id="input-group-2">
            <b-form-input
              id="input-1"
              v-model="email"
              type="text"
              placeholder="Email"
              :class="{
                'is-invalid': $v.email.$error || invalidEmail,
              }"
            />
          </b-form-group>
          <div class="mt-5">
            <b-button 
            type="submit" 
            variant="primary" 
            class="w-100" 
            :disabled="$v.email.$invalid"
              >{{ $t('profile.add.email.button') }}
            </b-button>
          </div>
        </b-form>
      </div>
      <div class="mc-auth__copyright">
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('login.text.presented') }}
          <img
            :src="getAsset('copyrightLogo', 'general')"
            alt="copyright"
            class="ms-2"
            ref="imgCopyrightLogo"
        /></span>
      </div>
    </div>
  </Layout>
</template>
